import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface ContactItemProps {
    icon: IconProp;
    children: React.ReactNode;
    align?: 'start' | 'center';
}

export function ContactItem({ icon, children, align = 'center' }: ContactItemProps) {
    const alignmentClass = align === "start" ? "items-start" : "items-center";

    const isStringChild = typeof children === "string";

    return (
        <div className={`mb-4 grid grid-cols-[50px_1fr] ${alignmentClass}`}>
            <FontAwesomeIcon icon={icon} style={{ color: "#00B0F0", fontSize: "1.25rem" }} />

            {isStringChild ? (
                <p className="text-sm md:text-base">{children}</p>
            ) : (
                <div className="text-sm md:text-base">{children}</div>
            )}
        </div>
    );
}
